import TEXT, { HTMLELEMENT } from '../../../../DOM/text/TEXT.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
import Translatable from '../../../../../interface/Translatable.js';
// Model Structure
export const legendAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['style']
]);
export const legendData = makeDataStruct([
    ['text', ''],
    ['textGroup', ''],
    ['textKey', '']
]);
export const legendModel = makeStruct([
    ['attributes', legendAttr],
    ['data', legendData]
]);
// Simplified Model
export function legend(text, textGroup, textKey) {
    return {
        attributes: legendAttr(),
        data: legendData(text, textGroup, textKey)
    };
}
/** Legend for a Fieldset */
export default class LEGEND extends TEXT {
    constructor(node, model) {
        super(node, HTMLELEMENT.LEGEND, model);
        this.implement(new Translatable(this));
    }
}
